import React from 'react';

import './button-group.css';

const ButtonGroup = ({ children, ...rest }) => {
  return (
    <div className="btn-group" {...rest}>
			{children}
    </div>
  );
};

export default ButtonGroup;


// WEBPACK FOOTER //
// ./src/components/common/form/ButtonGroup/index.js